import React from 'react';
import { Fab } from '@mui/material';
import { WhatsApp as WhatsAppIcon } from '@mui/icons-material';
import { handleWhatsApp } from './utils';

const FloatingWhatsApp: React.FC = () => {
  return (
    <Fab
      color="primary"
      sx={{
        position: 'fixed',
        bottom: 24,
        right: 24,
        backgroundColor: '#25d366',
        '&:hover': {
          backgroundColor: '#128c7e',
          transform: 'scale(1.1)'
        },
        transition: 'all 0.3s ease',
        zIndex: 1000
      }}
      onClick={() => handleWhatsApp()}
    >
      <WhatsAppIcon />
    </Fab>
  );
};

export default FloatingWhatsApp;
